"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepBar = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StepBar = exports.StepBar = _styledComponents["default"].ul.withConfig({
  displayName: "StepProgressBarstyle__StepBar",
  componentId: "sc-11h9e7i-0"
})({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  listStyleType: 'none',
  margin: 0,
  padding: 0
});